<template>
  <div class="ui modal" ref="modal">
    <div class="ui inverted dimmer">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="robot icon"></i>
      {{ $t("robocredit instance") }}
    </div>
    <div class="image scrolling content">
      <div class="ui small image">
        <img
          src="/images/icons/robocredit.png"
          style="width: 100% !important"
        />
      </div>
      <div class="description" style="width: 100% !important">
        <div class="ui three item top attached tabular menu" ref="tabs">
          <a class="active item" data-tab="request_rbc">{{ $t("request") }}</a>
          <a class="item" data-tab="general_rbc">{{ $t("ngine instance") }}</a>
          <a class="item" data-tab="flow_rbc">{{ $t("flow") }}</a>
        </div>
        <div
          class="ui bottom attached active tab segment"
          data-tab="request_rbc"
        >
          <request
            v-if="retrieved && retrieved.request_body"
            :request_body="retrieved.request_body"
            ref="request"
          />
          <div class="ui icon message" v-else>
            <i class="inbox icon"></i>
            <div class="content">
              <div class="header">
                {{ $t("alert") }}
              </div>
              <p>{{ $t("no request body received") }}</p>
            </div>
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="general_rbc">
          <general
            v-if="
              retrieved &&
                retrieved.ngn_instance &&
                retrieved.ngn_instance.payload
            "
            :instance="retrieved.ngn_instance"
            ref="general"
          />
          <div class="ui icon message" v-else>
            <i class="exclamation triangle icon"></i>
            <div class="content">
              <div class="header">
                {{ $t("alert") }}
              </div>
              <p>{{ $t("no ngine instance found") }}</p>
            </div>
          </div>
        </div>
        <div class="ui bottom attached tab segment" data-tab="flow_rbc">
          <flow
            v-if="
              retrieved &&
                retrieved.ngn_instance &&
                retrieved.ngn_instance.ngn_interactions
            "
            :instance="retrieved.ngn_instance"
            ref="flow"
          />
          <div class="ui icon message" v-else>
            <i class="exclamation triangle icon"></i>
            <div class="content">
              <div class="header">
                {{ $t("alert") }}
              </div>
              <p>{{ $t("no ngine instance found") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <div
        class="ui red left floated icon right labeled button"
        @click="remove"
      >
        <i class="trash icon"></i>
        {{ $t("remove") }}
      </div>
      <div class="ui blue icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import Request from "./Request.vue";
import General from "./General.vue";
import Flow from "./Flow.vue";
// import GenericModal from "@/components/GenericModal";

export default {
  name: "RobocreditInstanceModalIndex",
  components: {
    General,
    Request,
    Flow, // "generic-modal": GenericModal,
  },
  props: {
    branch_uuid: String,
  },
  computed: {},
  data() {
    return {
      setup: {},
      retrieved: {},
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;
      vm.setup = data;
      window
        .jQuery(vm.$refs.modal)
        .modal({
          onShow() {
            window
              .jQuery(vm.$refs.tabs)
              .find(".item")
              .tab();
          },
        })
        .modal("show");
      vm.init(data.robocredit_application_uuid);
    },
    remove() {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove robocredit instance?"),
        function() {
          local_api(vm, "post", "/robocredit/instance/do-delete", {
            u: vm.setup.robocredit_application_uuid,
          })
            .then(() => {
              window.jQuery(vm.$refs.modal).modal("hide");
              vm.$emit("deleted");
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
    init(robocredit_application_uuid) {
      let vm = this;
      local_api(vm, "post", "/robocredit/instance/do-monit", {
        u: robocredit_application_uuid,
      })
        .then((data) => {
          vm.retrieved = data;
          setTimeout(() => {
            if (vm.$refs.general) vm.$refs.general.update();
            if (vm.$refs.request) vm.$refs.request.update();
          }, 1000);
        })
        .catch((err) => {
          error_toast(err);
        });
    },
  },
  mounted() {
    // window.jQuery(this.$refs.form).form({
    //   fields: {
    //     name: ["empty"],
    //   },
    // });
  },
  watch: {},
  updated: function() {},
};
</script>
